import {
  buildWorkspaceQuery,
  handleWorkspaceJson,
  WORKSPACE_API_BASE,
  workspaceRequest,
} from "./workspaceApiShared";
import { buildAuthHeaders } from "./base";
import { normalizeWorkspace } from "../utils/workspacePresentation";

function normalizeWorkspaceList(rows) {
  return Array.isArray(rows) ? rows.map(normalizeWorkspace) : [];
}

export async function listManagedWorkspaces(token, salonId = null) {
  const suffix = buildWorkspaceQuery({ salon_id: salonId });
  const rows = await workspaceRequest(`/workspaces/managed${suffix}`, {
    token,
    fallback: "Unable to load managed workspaces.",
  });
  return normalizeWorkspaceList(rows);
}

export async function getWorkspace(id, token = null) {
  const row = await workspaceRequest(`/workspaces/${id}`, {
    token,
    fallback: "Unable to load workspace.",
  });
  return normalizeWorkspace(row);
}

export async function createWorkspace(payload, token) {
  const row = await workspaceRequest(`/workspaces`, {
    method: "POST",
    token,
    body: payload,
    fallback: "Unable to create workspace.",
  });
  return normalizeWorkspace(row);
}

export async function updateWorkspace(id, payload, token) {
  const row = await workspaceRequest(`/workspaces/${id}`, {
    method: "PUT",
    token,
    body: payload,
    fallback: "Unable to update workspace.",
  });
  return normalizeWorkspace(row);
}

export async function deleteWorkspace(id, token) {
  return workspaceRequest(`/workspaces/${id}`, {
    method: "DELETE",
    token,
    fallback: "Unable to delete workspace.",
  });
}

export async function getWorkspaceAvailability(id, params = {}) {
  return workspaceRequest(
    `/workspaces/${id}/availability${buildWorkspaceQuery(params)}`,
    {
      fallback: "Unable to check workspace availability.",
    }
  );
}

export async function listWorkspaceAvailabilityRules(id, token) {
  return workspaceRequest(`/workspaces/${id}/availability-rules`, {
    token,
    fallback: "Unable to load availability rules.",
  });
}

export async function replaceWorkspaceAvailabilityRules(id, payload, token) {
  return workspaceRequest(`/workspaces/${id}/availability-rules`, {
    method: "PUT",
    token,
    body: payload,
    fallback: "Unable to save availability rules.",
  });
}

export async function listWorkspaceBlackouts(id, token, params = {}) {
  return workspaceRequest(
    `/workspaces/${id}/blackouts${buildWorkspaceQuery(params)}`,
    {
      token,
      fallback: "Unable to load workspace blackouts.",
    }
  );
}

export async function createWorkspaceBlackout(id, payload, token) {
  return workspaceRequest(`/workspaces/${id}/blackouts`, {
    method: "POST",
    token,
    body: payload,
    fallback: "Unable to create workspace blackout.",
  });
}

export async function uploadWorkspacePhoto(id, file, token) {
  const formData = new FormData();
  formData.append("photo", file);
  const response = await fetch(`${WORKSPACE_API_BASE}/booths/${id}/photos`, {
    method: "POST",
    headers: {
      ...buildAuthHeaders(token),
    },
    credentials: "include",
    body: formData,
  });
  const row = await handleWorkspaceJson(
    response,
    "Unable to upload workspace photo."
  );
  return normalizeWorkspace(row);
}

export async function deleteWorkspacePhoto(id, photoUrl, token) {
  const query = new URLSearchParams({ photo_url: photoUrl }).toString();
  const response = await fetch(`${WORKSPACE_API_BASE}/booths/${id}/photos?${query}`, {
    method: "DELETE",
    headers: {
      ...buildAuthHeaders(token),
    },
    credentials: "include",
  });
  const row = await handleWorkspaceJson(
    response,
    "Unable to remove workspace photo."
  );
  return normalizeWorkspace(row);
}
